import React from 'react';
import { useFormikContext, getIn } from 'formik';

import { getTranslation } from 'helpers/getTranslation';

import { Typography } from 'components/shared/Typography';
import { Button } from 'components/shared/Button';

import { FormikField } from 'components/FormikField';
import { UploadField } from 'components/FormikFields';

import styles from './CanvasTheorySettings.styles.scss';

const CanvasTheorySettings = ({ files, onAddFileClick }) => {
  const { values } = useFormikContext();

  return (
    <div className={styles.section}>
      <div className={styles.header}>
        <Typography
          className={styles.headerText}
          variant="body1"
          weight="medium"
          mode="compact"
        >
          {getTranslation(
            'figma_lesson_page.main_settings.canvas_theory_section_title',
          )}
        </Typography>
      </div>
      <div className={styles.inner}>
        <Typography className={styles.text} variant="body1" mode="compact">
          {getTranslation(
            'figma_lesson_page.main_settings.files_section.select_image',
          )}
        </Typography>
        <div className={styles.files}>
          {files.map((_, fileIndex) => (
            <div className={styles.file} key={fileIndex}>
              <FormikField
                name={`canvasTheory.${fileIndex}.url`}
                withControl={false}
                component={UploadField}
                componentProps={{
                  readOnly: values.readOnly,
                  type: 'input',
                  variant: 'imageBlock',
                  className: styles.upload,
                  accept: {
                    'image/jpeg': ['.jpg', '.jpeg'],
                    'image/png': ['.png'],
                  },
                }}
              />
            </div>
          ))}
        </div>
        <Button variant="primary" onClick={onAddFileClick}>
          Add file
        </Button>
      </div>
    </div>
  );
};

export default React.memo(CanvasTheorySettings);
